/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
var tipologia_cerco = "185", tipologia_offro = "184", tipologia_prestito = "209";

jQuery(document).ready(function ($) {
    function base64ToFile(base64Data, tempfilename, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    var file = new File(byteArrays, tempfilename, { type: contentType });
    return file;
}
    /*button-inserimento-oggetto-visualizza-presente
     
     button-inserimento-oggetto-visualizza-nuovo
     visualizza-oggetti-presenti
     button-proponi-oggetto*/
    $("#button-inserimento-oggetto-visualizza-nuovo").click(function () {
        $("#inserimento-crea-oggetto-visualizza-div").fadeIn("slow");
        $("#visualizza-oggetti-presenti-div").fadeOut("slow");
        $("#button-proponi-oggetto").fadeOut("slow");
    });
    
    $(document).on('click','.button-segnala-abuso',function () {

        var r = confirm("Sei sicuro di voler segnalare questo annuncio?");
        if (r == true) {
            themeSpinner('show');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                cache: false,
                url: ajax_url,
                data:
                        {
                            action: 'segnala_abuso_action',
                            id_annuncio: this.value

                        },
                dataType: "html", //expect html to be returned                
                success: function (response) {
                    themeSpinner('hide');
                    $("#messagePrenotaAnnuncio").html('Annuncio segnalato');
                    $("#messagePrenotaAnnuncio").addClass('alert-success');
                    $("#messagePrenotaAnnuncio").show();
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messagePrenotaAnnuncio").html('Problema nella segnalazione dell\'annuncio');
                    $("#messagePrenotaAnnuncio").addClass('alert-danger');
                    $("#messagePrenotaAnnuncio").show();
                }

            });
        }
    });
    $(document).on('click','.button-rinnova-annuncio',function () {

        var r = confirm("Sei sicuro di voler rinnovare questo annuncio?");
        if (r == true) {
            themeSpinner('show');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                cache: false,
                url: ajax_url,
                data:
                        {
                            action: 'rinnova_annuncio_action',
                            id_annuncio: this.value

                        },
                dataType: "html", //expect html to be returned                
                success: function (response) {
                    themeSpinner('hide');
                    if (response === '1')
                    {
                        $("#alert-annuncio-scaduto").hide();
                        $(".button-rinnova-annuncio").remove();
                        $("#messageProponiAnnuncio").html('Annuncio rinnovato con successo per un altro mese');
                        $("#messageProponiAnnuncio").addClass('alert-success');
                        $("#messageProponiAnnuncio").show();
                    }
                    else
                    {
                        $("#messageProponiAnnuncio").html(response);
                        $("#messageProponiAnnuncio").addClass('alert-danger');
                        $("#messageProponiAnnuncio").show();
                    }
                    
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageProponiAnnuncio").html('Problema nel rinnovare l\'annuncio');
                    $("#messageProponiAnnuncio").addClass('alert-danger');
                    $("#messageProponiAnnuncio").show();
                }

            });
        }
    });
    $("#button-inserimento-oggetto-visualizza-presente").click(function () {
        themeSpinner('show');
        $.ajax({//create an ajax request to load_page.php
            type: "POST",
            cache: false,
            url: ajax_url,
            data:
                    {
                        action: 'recupera_oggetti_disponibili_action'
                    },
            dataType: "html", //expect html to be returned                
            success: function (response) {
                themeSpinner('hide');
                $("#visualizza-oggetti-presenti").html(response);
                $("#visualizza-oggetti-presenti-div").fadeIn("slow");
                $("#inserimento-crea-oggetto-visualizza-div").fadeOut("slow");
                $("#button-proponi-oggetto").fadeIn("slow");
            },
            error: function () {
                themeSpinner('hide');
                $("#messageSelectObject").html('Problemi nel recuperare gli oggetti');
                $("#messageSelectObject").addClass('alert-danger');
                $("#messageSelectObject").show();
            }

        });
    });
    $("#button-proponi-oggetto").click(function () {
        if ($("#visualizza-oggetti-presenti").val() !== '')
        {
            themeSpinner('show');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                cache: false,
                url: ajax_url,
                data:
                        {
                            id_oggetto: $("#visualizza-oggetti-presenti").val(),
                            id_annuncio: $('#id_annuncio').val(),
                            action: 'proponi_oggetto_action'
                        },
                dataType: "html", //expect html to be returned                
                success: function (response) {
                    if (response === '1')
                    {
//                        $("#inserimento-oggetto-visualizza-tipologia-div").hide();
//                        $("#messageNewObject").hide();
//                        $("#visualizza-oggetti-presenti-div").hide();
//                        $("#button-proponi-oggetto").hide();
//                        $("#messageProponiAnnuncio").html('Oggetto proposto con Successo');
//                        $("#messageProponiAnnuncio").addClass('alert-success');
//                        $("#messageProponiAnnuncio").show();
                        $(document).scrollTop($("#table-dati-annuncio").offset().top);
                        location.reload();
                    }
                    else
                    {
                        $("#messageProponiAnnuncio").html(response);
                        $("#messageProponiAnnuncio").addClass('alert-danger');
                        $("#messageProponiAnnuncio").show();
                    }
                    themeSpinner('hide');
                    
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageProponiAnnuncio").html("Problemi nel proporre l'oggetto");
                    $("#messageProponiAnnuncio").addClass('alert-danger');
                    $("#messageProponiAnnuncio").show();
                }

            });
        }
        else
        {
            $("#messageProponiAnnuncio").html("");
            $("#messageProponiAnnuncio").removeClass('alert-danger', 'alert-success');
            $("#messageProponiAnnuncio").hide();
            rimuovi_stato('#visualizza-oggetti-presenti');
            stato_errore('#visualizza-oggetti-presenti', 'Campo richiesto');
        }
    });
    $('#inserimento-crea-oggetto-visualizza-nome').change(function () {

        rimuovi_stato('#inserimento-crea-oggetto-visualizza-nome');
        $('#messageNewObject').html(''); // Add success message to results div
        $('#messageNewObject').removeClass('alert-danger');
        $('#messageNewObject').removeClass('alert-success'); // Add class success to results div
        $('#messageNewObject').hide();
    });
    $('#inserimento-crea-oggetto-visualizza-descrizione').change(function () {

        rimuovi_stato('#inserimento-crea-oggetto-visualizza-descrizione');
        $('#messageNewObject').html(''); // Add success message to results div
        $('#messageNewObject').removeClass('alert-danger');
        $('#messageNewObject').removeClass('alert-success'); // Add class success to results div
        $('#messageNewObject').hide();
    });
    $('#inserimento-crea-oggetto-visualizza-categoria').change(function () {

        rimuovi_stato('#inserimento-crea-oggetto-visualizza-categoria');
        $('#messageNewObject').html(''); // Add success message to results div
        $('#messageNewObject').removeClass('alert-danger');
        $('#messageNewObject').removeClass('alert-success'); // Add class success to results div
        $('#messageNewObject').hide();
    });
    $("#button-inserimento-crea-oggetto-visualizza").click(function () {
        var reg_nome = $('#inserimento-crea-oggetto-visualizza-nome').val();
        var reg_descrizione = $('#inserimento-crea-oggetto-visualizza-descrizione').val();
        var reg_categoria = $('#inserimento-crea-oggetto-visualizza-categoria').val();
        var reg_taglia = $('#inserimento-crea-oggetto-visualizza-taglia').val();
        var reg_foto_1 = $('#inserimento-crea-oggetto-visualizza-foto-1')[0].files[0];
        //var reg_foto_2 = $('#inserimento-annuncio-altri-campi-foto-2').val();
        var reg_foto_2 = $('#inserimento-crea-oggetto-visualizza-foto-2')[0].files[0];
        //var reg_foto_3 = $('#inserimento-annuncio-altri-campi-foto-3').val();
        var reg_foto_3 = $('#inserimento-crea-oggetto-visualizza-foto-3')[0].files[0];
        var faiAjax = true;
        if (reg_nome == '')
        {
            rimuovi_stato('#inserimento-crea-oggetto-visualizza-nome');
            stato_errore('#inserimento-crea-oggetto-visualizza-nome', 'Campo richiesto');
            faiAjax = false;
        }
        else
        {
            rimuovi_stato('#inserimento-crea-oggetto-visualizza-nome');
            stato_success('#inserimento-crea-oggetto-visualizza-nome');
        }
        if (reg_categoria == null || reg_categoria == '')
        {
            rimuovi_stato('#inserimento-crea-oggetto-visualizza-categoria');
            stato_errore('#inserimento-crea-oggetto-visualizza-categoria', 'Campo richiesto');
            faiAjax = false;
        } else
        {
            rimuovi_stato('#inserimento-crea-oggetto-visualizza-categoria');
            stato_success('#inserimento-crea-oggetto-visualizza-categoria');
        }
        if (typeof(reg_foto_1) !== 'undefined' && reg_foto_1 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_1);
            if (tmp)
            {
                rimuovi_stato('#inserimento-crea-oggetto-visualizza-foto');
                stato_success('#inserimento-crea-oggetto-visualizza-foto');
            }
            else
            {
                faiAjax = false;
                rimuovi_stato('#inserimento-crea-oggetto-visualizza-foto');
                msgtmp = 'Attenzione il file 1 deve essere in formato jpeg o png  e non superiore a 8MB';
                stato_errore('#inserimento-crea-oggetto-visualizza-foto', msgtmp);
            }
        }
        else
        {
            if ($('input[name=inserimento-annuncio-tipologia]:checked').val() !== tipologia_cerco)// se non è un cerco  è obbligatoria la foto
            {
                faiAjax = false;
                rimuovi_stato('#inserimento-crea-oggetto-visualizza-foto');
                msgtmp = 'Attenzione la foto 1 è obbligatoria';
                stato_errore('#inserimento-crea-oggetto-visualizza-foto', msgtmp);
            }
        }
         if (typeof(reg_foto_2) !== 'undefined' && reg_foto_2 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_2);
            if (tmp)
            {
                rimuovi_stato('#inserimento-crea-oggetto-visualizza-foto');
                stato_success('#inserimento-crea-oggetto-visualizza-foto');
            }
            else
            {
                faiAjax = false;
                msgtmp += '<br>Attenzione il file 2 deve essere in formato jpeg o png  e non superiore a 8MB';
                rimuovi_stato('#inserimento-crea-oggetto-visualizza-foto');
                stato_errore('#inserimento-crea-oggetto-visualizza-foto', msgtmp);
            }
        }
         if (typeof(reg_foto_3) !== 'undefined' && reg_foto_3 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_3);
            if (tmp)
            {
                rimuovi_stato('#inserimento-crea-oggetto-visualizza-foto');
                stato_success('#inserimento-crea-oggetto-visualizza-foto');
            }
            else
            {
                faiAjax = false;
                msgtmp += '<br>Attenzione il file 3 deve essere in formato jpeg o png  e non superiore a 8MB';
                rimuovi_stato('#inserimento-crea-oggetto-visualizza-foto');
                stato_errore('#inserimento-crea-oggetto-visualizza-foto', msgtmp);
            }
        }
        if (faiAjax)
        {
            themeSpinner('show');
            form = new FormData();
            form.append('descrizione', $("#inserimento-crea-oggetto-visualizza-descrizione").val());
            form.append('categoria', $("#inserimento-crea-oggetto-visualizza-categoria").val());
            form.append('tagliaoggetto', reg_taglia);
            form.append('titolo', $("#inserimento-crea-oggetto-visualizza-nome").val());
            dataURL1=$('#inserimento-crea-oggetto-visualizza-immaginecompressa-1').attr('src');
            var file1=base64ToFile(dataURL1.split(',')[1], reg_foto_1.name, 'image/jpeg');
            var file2=null;
            var file3 =null;
            if (typeof(reg_foto_2) !== 'undefined' && reg_foto_2 != null)
            {
                dataURL2=$('#inserimento-crea-oggetto-visualizza-immaginecompressa-2').attr('src');
                file2=base64ToFile(dataURL2.split(',')[1], reg_foto_2.name, 'image/jpeg');
            }
            if (typeof(reg_foto_3) !== 'undefined' && reg_foto_3 != null)
            {
                dataURL3=$('#inserimento-crea-oggetto-visualizza-immaginecompressa-3').attr('src');
                file3=base64ToFile(dataURL3.split(',')[1], reg_foto_3.name, 'image/jpeg');
            }
            form.append('foto_1', file1);
            form.append('foto_2', file2);
            form.append('foto_3', file3);
            form.append('action', 'inserimento_oggetto_utente_action');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                data: form,
                mimeType: 'multipart/form-data',
                contentType: false,
                cache: false,
                processData: false,
                url: ajax_url,
                dataType: "html", //expect html to be returned              
                success: function (resp) {
                    themeSpinner('hide');
                    $("#messageNewObject").html('Oggetto Inserito con Successo');
                    $("#messageNewObject").addClass('alert-success');
                    $("#messageNewObject").show();
                    /*
                     *  recupero oggetto disponibili via ajax
                     */
                    themeSpinner('show');
                    $.ajax({//create an ajax request to load_page.php
                        type: "POST",
                        cache: false,
                        url: ajax_url,
                        data:
                                {
                                    action: 'recupera_oggetti_disponibili_action'
                                },
                        dataType: "html", //expect html to be returned                
                        success: function (response) {
                            themeSpinner('hide');
                            $("#button-proponi-oggetto").fadeIn("slow");
                            $("#visualizza-oggetti-presenti").html(response);
                            $("#visualizza-oggetti-presenti-div").fadeIn("slow");
                            $("#inserimento-annuncio-altri-campi-div").fadeIn("slow");  
                            $("#inserimento-crea-oggetto-visualizza-div").fadeOut("slow");
                            $("#visualizza-oggetti-presenti").val(resp);
                        },
                        error: function () {
                            themeSpinner('hide');
                            $("#messageSelectObject").html('Problemi nel recuperare gli oggetti');
                            $("#messageSelectObject").addClass('alert-danger');
                            $("#messageSelectObject").show();
                        }

                    });
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageNewObject").html('Problemi nell\' inserimento dell\' oggetto');
                    $("#messageNewObject").addClass('alert-danger');
                    $("#messageNewObject").show();
                }

            });
        }

    });
});